import { ReportCategoryInterface } from "../../domain/interface/report_category_interface";
import { ReportInterface } from "../../domain/interface/report_interface";
import { ReportRepository } from "../../domain/repository/report_repository";
import { ReportApiService } from "../data_source/report_api_service";
import { ReportCategoryApiService } from "../data_source/report_category_api_service";

interface ReportCategoryDto {
    _id: string;
    name: string;
    active?: boolean;
}

export class ReportRepositoryImpl implements ReportRepository {
    private reportCategoryApiService: ReportCategoryApiService;
    private reportApiService: ReportApiService;

    constructor() {
        this.reportCategoryApiService = new ReportCategoryApiService();
        this.reportApiService = new ReportApiService();
    }

    async getReportCategories(): Promise<ReportCategoryInterface[]> {
        const response = await this.reportCategoryApiService.getReportCategories();
        if (response.status == 200) {
            const result: ReportCategoryInterface[] = response.data.map((category: ReportCategoryDto) => {
                if (category['active'] === true) {
                    return {
                        id: category['_id'],
                        name: category['name'],
                    };
                }
            });
            return result;
        }
        throw new Error("Failed to fetch report categories");
    }

    async report(report: ReportInterface): Promise<void> {
        const json = JSON.stringify({
            entityId: report.meetingId,
            entityType: "Meeting",
            gravity: report.severity,
            message: report.message,
            reportCategoryId: report.reportCategoryId
        });
        await this.reportApiService.report(json);
    }

}